import { render } from "./PaymentPlatform.vue?vue&type=template&id=771c142f&scoped=true"
import script from "./PaymentPlatform.vue?vue&type=script&lang=js"
export * from "./PaymentPlatform.vue?vue&type=script&lang=js"

import "./PaymentPlatform.vue?vue&type=style&index=0&id=771c142f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771c142f"]])

export default __exports__